import React, { FC } from 'react';
import Accordion from '~ComponentsImproved/Accordion';
import Icon from '~ComponentsImproved/Icon';
import Heading from '~ComponentsImproved/Typography/Heading';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import { useI18n, usePrinterApi, useSelector } from '~Hooks';
import { BongPrint } from '~reducers';
import { Box } from '~Styles';
import ReceiptLongIcon from '~Assets/icons/receipt_long.svg';
import _ from 'lodash';
import { StyledBox } from '~Components/PrinterStatus/styles';

interface Props {
  bong: BongPrint;
}

const BongPrintRow: FC<Props> = ({ bong }) => {
  const { i18n } = useI18n();

  const printerApi = usePrinterApi();
  const printers = useSelector((state) => state.printers);

  const printer = printers.find((p) => p.id === bong.printerId);
  const printerName = printer?.id
    ? printerApi.getNameFromId(printer?.id) || bong.printerId
    : printer?.id || bong.printerId;

  return (
    <StyledBox padding="xs">
      <Box display="flex" alignItems="center" gap="xs">
        <Icon
          src={ReceiptLongIcon}
          height="32px"
          width="32px"
          color={bong.hasBeenAttempted ? 'var(--colorUIGreen)' : 'var(--colorUIRed)'}
        />
        <Box display="flex" flexDirection="column" alignItems="flex-start">
          <Paragraph level={5}>{`${i18n('Settings.Printer')}: ${printerName}`}</Paragraph>
          <Heading level={4}>{bong.reason}</Heading>
        </Box>
      </Box>
    </StyledBox>
  );
};

export default BongPrintRow;
